export default "__VITE_ASSET__BsgQtstp__"